import { put, takeLatest, call } from 'redux-saga/effects';

import { serializeKeys } from '@iso/lib/helpers/keyNormalizer';
import request from '@iso/lib/helpers/httpClient';

import * as CONSTANTS from './constants';
import * as ACTIONS from './actions';

function* cancelDeferredTransaction({ payload }) {
  try {
    const data = yield call(
      request,
      `/deferred_transactions/${payload.transactionId}/cancel`,
      'POST',
      null,
      true
    );
    yield put(ACTIONS.cancelDeferredTransactionSuccess(serializeKeys(data)));
    payload.cb();
  } catch (error) {
    yield put(ACTIONS.cancelDeferredTransactionFail(error));
  }
}

function* checkIfCanceledDeferredTransaction({ payload }) {
  try {
    const data = yield call(
      request,
      `/deferred_transactions/${payload.transactionId}/`,
      'GET',
      null,
      false
    );
    yield put(
      ACTIONS.checkIfCanceledDeferredTransactionSuccess(serializeKeys(data))
    );
  } catch (error) {
    yield put(ACTIONS.checkIfCanceledDeferredTransactionFail(error));
  }
}

function* getCompanyDeferredTransactions({ payload }) {
  try {
    const data = yield call(
      request,
      `/company/${payload.companyId}/deferred_transactions/`,
      'GET',
      null,
      true
    );
    yield put(
      ACTIONS.fetchDeferredCompanyTransactionSuccess(serializeKeys(data))
    );
  } catch (error) {
    yield put(ACTIONS.fetchDeferredCompanyTransactionFail(error));
  }
}

function* getUserDeferredTransactions() {
  try {
    const data = yield call(
      request,
      '/user/deferred_transactions/',
      'GET',
      null,
      true
    );
    yield put(ACTIONS.fetchDeferredUserTransactionSuccess(serializeKeys(data)));
  } catch (error) {
    yield put(ACTIONS.fetchDeferredUserTransactionFail(error));
  }
}

export default function* payByInvitationSaga() {
  yield takeLatest(
    CONSTANTS.CANCEL_DEFERRED_TRANSACTION_REQUEST,
    cancelDeferredTransaction
  );
  yield takeLatest(
    CONSTANTS.CHECK_IF_CANCELED_DEFERRED_TRANSACTION_REQUEST,
    checkIfCanceledDeferredTransaction
  );
  yield takeLatest(
    CONSTANTS.FETCH_DEFERRED_COMPANY_TRANSACTION_REQUEST,
    getCompanyDeferredTransactions
  );
  yield takeLatest(
    CONSTANTS.FETCH_DEFERRED_USER_TRANSACTION_REQUEST,
    getUserDeferredTransactions
  );
}
